import RSA from './rsa.js';
let CryptoJS = require('./crypto-js.js');
var RSA_PUBLIC =
  '-----BEGIN PUBLIC KEY-----\
    MIGeMA0GCSqGSIb3DQEBAQUAA4GMADCBiAKBgGj8WNUSzCn0rHqfIXk9XPdJp60u\
    JnM+mVZVxY1lZmUCVA7t3eJZ0R0z1hUHkVb51eryDZcsz0QLSav3cmQv00ullK18\
    8aOs2SXZe6rcQf6XmOsVBqgADkrN+WePZJmb5Fr0NUkQ/sr7+R71cDZ87Y9QKm99\
    8BFOiWoEGxWWvDsTAgMBAAE=\
        -----END PUBLIC KEY-----';
// window.getGiftCallBack = function (getAppData) {
//   // store.dispatch('getAppId',getAppData)
// }

import axios from 'axios';
import Qs from 'qs';
var surl = window.location.href;
// if(window.location.href.indexOf('/wechat') > -1 && (location.hostname == 'localhost' || location.hostname == '192.168.1.129')){
//   surl = 'http://aitest.lanlingcb.com//#/wechat?postId=7256&env=test'
// }else if(window.location.href.indexOf('/register') > -1 && (location.hostname == 'localhost' || location.hostname == '192.168.1.129')){
//   surl = 'http://aidev.lanlingcb.com/#/register?user_id=32742&version=2.4.2&env=test&os=wxapplet_happy_group&token=bearer%20bd80e7b4-785e-45c2-8e94-14c6f5f788f3'
// }else if(window.location.href.indexOf('/appleTree') > -1 && (location.hostname == 'localhost' || location.hostname == '192.168.1.129')){
//   surl = 'http://aidev.lanlingcb.com/?user_id=32588&owner=32588&version=2.7.1&device=h5&os=h5'
// }else if(location.hostname == 'localhost' || location.hostname == '192.168.1.129'){
//   surl = 'http://aidev.lanlingcb.com/?user_id=31901&version=2.7.0&os=wxapplet_happy_group&token=bearer b4ffc94c-5937-4d4b-a9a6-fd175e74d457#/home'
// }
var obj = {};
var urls = surl.substr(surl.indexOf('?') + 1).split('&');
for (var i = 0; i < urls.length; i++) {
  var temp = urls[i].split('=');
 obj[temp[0]] = temp[1];
}
// 去除不必要的传参 
// 青春泡泡相关
if(window.location.href.indexOf('/youthBlindBox') > -1){
  delete obj['cityCode']
  delete obj['active']
  delete obj['single']
  delete obj['openBox']
}

if(obj.os === 'wxapplet_happy_group'){
  localStorage.setItem('os', obj.os);
}


// 针对苹果树活动设置特定的请求接口的域名
if(window.location.href.indexOf('register') > -1){
  axios.defaults.baseURL = process.env.VUE_APP_KSH_URL;
  // axios.defaults.baseURL = 'https://prekshuser.kaishuihu.com/ksh-user'
  // axios.defaults.baseURL = 'http://kshusertest.lanlingcb.com/ksh-user'
  // axios.defaults.baseURL = 'http://kshuserdev.lanlingcb.com/ksh-user'
  
  obj.user_id = obj.code || obj.user_id
}else{
  axios.defaults.baseURL = process.env.VUE_APP_API_URL;
  // axios.defaults.baseURL = 'https://prellcb.kaishuihu.com/dsgc'
  // axios.defaults.baseURL = 'http://kshuserdev.lanlingcb.com/ksh-user'
}
// 设置请求超时时间
axios.defaults.timeout = 30000;

axios.defaults.headers.post['Content-Type'] =
  'application/x-www-form-urlencoded';

let token = obj.token || '';
// 响应拦截
axios.interceptors.response.use(
  (response) => {
    // console.log(response,'状态码')
    // 对响应数据做点什么
    if (response.status === 200) {
      //响应成功后
      if (response.headers['token']) {
        //获取响应头里面的数据，**Authorization根据你响应头里面的数据获取，并不是唯一值**
        sessionStorage.setItem('token', response.headers['token']);
      }
      return Promise.resolve(response);
    } else if (response.data.code === 401) {
      alert('请重新登录');
    } else {
      return Promise.reject(response);
    }
  },
  (error) => {
    // 对响应错误做点什么
    if (error) {
      switch (error.code) {
        case 401:
          alert('请重新登录');
      }
    }
    return Promise.reject(error.data);
  }
);

// 封装get方法和post方法

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function get(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        params: params,
        // headers: {
        //   Authorization:  "Bearer " + sessionStorage.getItem('token')
        // }
      })
      .then((res) => {
        resolve(res.data);
        //  Loading.service(true).close();
        //  Message({message: '请求成功', type: 'success'});
      })
      .catch((err) => {
        reject(err.msg);
        //  Loading.service(true).close();
        // Message({ message: err.msg, type: "error" });
      });
  });
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function post({ url, data = {} }) {
  if(window.location.href.indexOf('/register') > -1){
    data.inviteUserId = obj.user_id
    if(process.env.VUE_APP_API_URL == 'https://llcbdev.lanlingcb.com/dsgc'){
      data.env = 'dev'
    }else if(process.env.VUE_APP_API_URL == 'https://kshtest.lanlingcb.com/dsgc'){
      data.env = 'test'
    }else if(process.env.VUE_APP_API_URL == 'https://prellcb.kaishuihu.com/dsgc'){
      data.env = 'gray'
    }else if(process.env.VUE_APP_API_URL == 'https://llcb.kaishuihu.com/dsgc'){
      data.env = 'prod'
    }
    data.code = obj.user_id
    console.log(data,'data')
  }
  let formData = new FormData();
  Object.assign(data, obj);
  
  console.log('data', data, 'url', url);
  // 要加密（RSA）的随机字符串privateKey（随机生成）
  var timestamp = new Date().getTime();
  var randomStr = CryptoJS.MD5(timestamp.toString()).toString();
  var privateKey = RSA.encrypt(randomStr, RSA.getPublicKey(RSA_PUBLIC));
  axios.defaults.headers.post['privateKey'] = privateKey;
  var a = Date.now();
  if (window.location.href.indexOf('/wechat') > -1) {
    sessionStorage.setItem('postId',obj.postId)
    data.accessType = 4
    data.url = window.location.href
    var encrypt = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      CryptoJS.enc.Utf8.parse(randomStr),
      {
        iv: CryptoJS.enc.Utf8.parse(randomStr.substr(0, 16)),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    var sign = encrypt.toString(); //加密后的数据
    formData.append('sign', sign);
  } else {
    // 要加密（RSA）的随机字符串privateKey（随机生成）
    if (token && token != '') {
      axios.defaults.headers.post['token'] = decodeURIComponent(token);
      axios.defaults.headers.post['Authorization'] = decodeURIComponent(token);
    }
    axios.defaults.headers.post['version'] = obj.version;
    let ocj = {
      privateKey: privateKey,
      sendTime: a,
      user_id: obj.user_id,
    };
    Object.assign(data, ocj);
    var encrypt = CryptoJS.AES.encrypt(
      JSON.stringify(data),
      CryptoJS.enc.Utf8.parse(randomStr),
      {
        iv: CryptoJS.enc.Utf8.parse(randomStr.substr(0, 16)),
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    var sign = encrypt.toString(); //加密后的数据
    formData.append('sign', sign);
  }
  return new Promise((resolve, reject) => {
    axios
      .post(url, formData)
      .then((res) => {
        // console.log('请求地址', url, '参数', data, '结果：', res.data);
        resolve(res.data);
      })
      .catch((err) => {
        reject(err.msg);
      });
  });
}

/**
 * post方法，参数序列化
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function qspost(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .post(url, Qs.stringify(params))
      .then((res) => {
        resolve(res.data);
        //  Loading.service(true).close();
        //  Message({message: '请求成功', type: 'success'});
      })
      .catch((err) => {
        reject(err.msg);
        // Loading.service(true).close();
        // Message({ message: err.msg, type: "error" });
      });
  });
}

/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function put(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .put(url, params)
      .then((res) => {
        resolve(res.data);
        // Loading.service(true).close();
        //  Message({message: '请求成功', type: 'success'});
      })
      .catch((err) => {
        reject(err.msg);
        // Loading.service(true).close();
        // Message({ message: err.msg, type: "error" });
      });
  });
}

/**
 * delete
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function deletefn(url, params) {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, params)
      .then((res) => {
        resolve(res.data);
        // Loading.service(true).close();
        //  Message({message: '请求成功', type: 'success'});
      })
      .catch((err) => {
        reject(err.data);
        // Loading.service(true).close();
        // Message({ message: err.msg, type: "error" });
      });
  });
}
